webpackJsonp([190519597166818],{

/***/ 1285:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/leads-program/"},"frontmatter":{"title":"LEADS and Associated Services","subTitle":"In addition to a law enforcement assisted diversion program, a Resource Navigator helped individuals successfully transition back to the community.","date":"2018-10-09","category":"Policing"}}}]}},"pathContext":{"posts":[{"title":"LEADS and Associated Services","slug":"/leads-program/"}],"tagName":"Diversion","tagCount":1}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-diversion-e10b3c6e0c69447ec3c1.js